import React, { FunctionComponent } from 'react';

import { features } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';
import useMediaQuery, { MediaQueryWidth } from 'lib/use-media-query';

import PageSectionCardCarousel from 'components/page/sections/page-section-card-carousel';
import PageSectionCards, {
  PageSectionCardsProps,
} from 'components/page/sections/page-section-cards';

export const IncognitoModeBlockThreeContainer: FunctionComponent = () => {
  const props = {
    title: features.incognitoMode.lxIncognitoModeThreeBlockTitle,
    items: [
      {
        imageSrc: `${CdnImagePath}/landing/assets/illustrations/features/incognito-mode/incognito-mode-love-incognito-1.svg`,
        title: features.incognitoMode.lxIncognitoModeThreeBlockSubtitleOne,
        text: features.incognitoMode.lxIncognitoModeThreeBlockBodyTextOne,
        titleTag: 'h3',
      },
      {
        imageSrc: `${CdnImagePath}/landing/assets/illustrations/features/incognito-mode/incognito-mode-love-incognito-2.svg`,
        title: features.incognitoMode.lxIncognitoModeThreeBlockSubtitleTwo,
        text: features.incognitoMode.lxIncognitoModeThreeBlockBodyTextTwo,
        titleTag: 'h3',
      },
      {
        imageSrc: `${CdnImagePath}/landing/assets/illustrations/features/incognito-mode/incognito-mode-love-incognito-3.svg`,
        title: features.incognitoMode.lxIncognitoModeThreeBlockSubtitleThree,
        text: features.incognitoMode.lxIncognitoModeThreeBlockBodyTextThree,
        titleTag: 'h3',
      },
    ] as PageSectionCardsProps['cards'],
  };

  const isMobile = useMediaQuery(MediaQueryWidth['navigation-full']);

  return (
    <>
      {isMobile ? (
        <PageSectionCardCarousel title={props.title} cards={props.items} />
      ) : (
        <PageSectionCards title={props.title} cards={props.items} color="orange" styling="filled" />
      )}
    </>
  );
};
